import React from "react";
import Button from "../../components/Buttons/Button";
import { SECTIONIDS } from "../../constants/sectionId";
import { Helmet } from "react-helmet";
interface NotFoundProps {
  id?: string;
}

const NotFound: React.FC<NotFoundProps> = ({ id }) => {
  return (
    <>
      <section className="flex items-center h-screen w-full p-16 bg-black mx-auto">
        <Helmet>
          {/* Title */}
          <title>Erom Studio | 404</title>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
        <div className="container mx-auto flex flex-col items-center ">
          <div className="flex flex-col gap-6 max-w-md text-center">
            <h2 className="font-extrabold text-9xl text-gray-600 dark:text-gray-100">
              <span className="sr-only">Error</span>404
            </h2>
            <p className="text-2xl md:text-3xl dark:text-gray-300">
              Sorry, we couldn't find this page.
            </p>
            <Button label="Back Home" href={`/#${SECTIONIDS.HERO}`} />
          </div>
        </div>
      </section>
    </>
  );
};

export default NotFound;
